import api from "@/api/api-v2-config";

export async function getPurchaseInvoicesListAxios() {    
    return await api.get("purchaseinvoices?pageNumber=1&pageSize=10000");
}

export async function deletePurchaseInvoicesAxios(id) {    
    return await api.delete("purchaseinvoices?Id=" + id);
}

export async function postPurchaseInvoicesAxios(purchaseinvoices) {    
    return await api.post("purchaseinvoices", purchaseinvoices);
}

export async function putPurchaseInvoicesAxios(purchaseinvoices) {    
    return await api.put("purchaseinvoices", purchaseinvoices);
}

export async function getPurchaseInvoicesByIDAxios(id) {    
    return await api.get("purchaseinvoices/" + id);
}

// export async function getProductOrderAxios(productorder) {    
//     return await api.get("purchaseinvoices/getproductorder", productorder);
// }

export async function getPurchaseInvoiceDocumentList(ReferenceID) {
    return await api.get(`purchaseinvoices/files?ReferenceID=${ReferenceID}&PageNumber=1&PageSize=10000`);
}

export async function deletePurchaseInvoiceDocument(id) {
    return await api.delete("purchaseinvoices/files/" + id);
}

export async function uploadPurchaseInvoiceDocument(file, referenceId, type, typeId) {
    console.log(file, referenceId);
    const formData = new FormData();
    formData.append('File', file[0]);
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('purchaseinvoices/files/upload', formData);
}

export async function uploadPurchaseInvoiceMultipleDocuments(files, referenceId, type, typeId) {
    console.log(files, referenceId);
    const formData = new FormData();
    files.forEach(file => {
        formData.append('Files', file);
    });
    formData.append('ReferenceId', referenceId);
    formData.append('type', type);
    formData.append('typeId', typeId);
    api.defaults.headers["Content-Type"] = "multipart/form-data";
    return await api.post('purchaseinvoices/files/uploads', formData);
}

export async function downloadPurchaseInvoiceDocument(id) {
    api.defaults.headers["responseType"] = "blob";
    return await api.get("purchaseinvoices/files/download/" + id);
}